import ConnectionPreview from './ConnectionPreview';

export default {
  __init__: [ 'connectionPreview' ],
  connectionPreview: [ 'type', ConnectionPreview ]
};
